import * as tslib_1 from "tslib";
import { ConfigService } from '../services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/config.service";
export class NewsGuard {
    constructor(configService) {
        this.configService = configService;
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.configService.getInitialInfo().then((response) => {
                return response;
            });
            let modulesEnabled = yield this.configService.company_info.modules_enabled;
            if (modulesEnabled) {
                if (modulesEnabled.includes('NEWS')) {
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
}
NewsGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NewsGuard_Factory() { return new NewsGuard(i0.ɵɵinject(i1.ConfigService)); }, token: NewsGuard, providedIn: "root" });
